import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse, ELEMENT_TYPE, HomeworkType } from '@umu/umu-types';

interface IInput {
    course_id: string;
    type: ELEMENT_TYPE;
}

interface IOutput {
    list: Array<{
        session_id: string;
        session_title: string;
        homework_type: string;
    }>;
    homework_types: HomeworkType[];
}

// 获取课程下某个类型的所有小节
export const getCourseTypeSessions = (param: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(API.GET_COURSE_TYPE_SESSIONS, {
        ...param,
        filter_private: 1, // 是否过滤已关闭小节 0 否 1 是  固定传 1
    });
};
